import React, { FC } from 'react';
import { formatDate } from '@/services/utils/date-time';

interface Props {
  readonly startDate: Date | string;
  readonly endDate: Date | string;
  readonly formatter: string;
}

const ReservationDates : FC<Props> = ({ startDate, endDate, formatter } : Props) => {
  const startDateString = formatDate(startDate, formatter);
  const endDateString = formatDate(endDate, formatter);

  return (
    <>
      {startDateString} &rarr; {endDateString}
    </>
  );
};

export default ReservationDates;
